import { WritableDraft } from 'immer';

import { QuoteBuilderStateType } from '../../types/state';

export function showAllMarketCodeToggled(
  state: WritableDraft<QuoteBuilderStateType>,
) {
  state.showAllMarketCodes = !state.showAllMarketCodes;
}
